import request from '../../utils/request.js'

export function getVerifyCode(params) {
  return request('post', 'captcha', params)
}
export function getImageCode(params) {
    return request('post', 'img-captcha', params)
}
export function setBind(params) {
    return request('post', 'mobile-login', params)
}



// WEBPACK FOOTER //
// ./src/api/bind.js